import { render, staticRenderFns } from "./AssignedStudents.vue?vue&type=template&id=d4a49cd4&scoped=true&"
import script from "./AssignedStudents.vue?vue&type=script&lang=js&"
export * from "./AssignedStudents.vue?vue&type=script&lang=js&"
import style0 from "./AssignedStudents.vue?vue&type=style&index=0&id=d4a49cd4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a49cd4",
  null
  
)

export default component.exports